import { ThemeFactory } from "../../../lib/theming/ThemeFactory";
export var getModalBodyTheme = function getModalBodyTheme(theme) {
  return ThemeFactory.create({
    loaderBorderRadius: theme.modalBodyBorderRadius
  }, theme);
};